import { Bid, Call, SharkGameResultsV2 } from '../../app/types';
import { GameEngine, convertCalltoStrain, convertIntToCall } from '../game-engine-helper';
import { SFSObject } from 'sfs2x-api';
import { SFSVAR } from '../sfsVar';
import { convertIntToBid } from '../shark-game-engine-helper';
import {
    lineForMinMaxValue,
    lineForPoints,
    lineForSimpleString,
    lineForSuitEndingWith,
} from '../handle-bid-explanation';

export function MID_SHOW_BID_EXPL(cmdObj: SFSObject, sender: GameEngine) {
    let expl: object | undefined = undefined;
    if (!cmdObj.containsKey('expl')) {
        return;
    }
    const json = new TextDecoder().decode(cmdObj.getByteArray('expl'));
    expl = JSON.parse(json) as object;
    if (!expl) {
        return;
    }
    const receivedCall: Bid = convertIntToBid(cmdObj.getInt(SFSVAR.SFSGAME_MID_LOAD));

    if ( !sender.waitingForBidExpl || (sender.waitingForBidExpl.call !== receivedCall.call)) {
        return;
    }
    const call: unknown = 'call' in expl ? expl['call'] : undefined;
    const hand: unknown | undefined = 'hand' in expl ? expl['hand'] : undefined;

    let message = '';
    if ('alert' in expl) {
        message += '</br>' + lineForSimpleString('alert', expl);
    } else if (call || hand) {
        message += lineForPoints(call, hand) ?? '';
        // lineForMinMaxValue(call, 'minl', 'maxl', 'Losers: ')
        message += lineForSuitEndingWith('spade', call, hand) ?? '';
        message += lineForSuitEndingWith('heart', call, hand) ?? '';
        message += lineForSuitEndingWith('diamond', call, hand) ?? '';
        message += lineForSuitEndingWith('club', call, hand) ?? '';
        message += lineForMinMaxValue('minaces', 'maxaces', 'Aces: ', call) ?? '';
        message += lineForSimpleString('distro', call) ?? '';
        message += lineForSimpleString('conv', call) ?? '';
        if (hand) {
            message += lineForSimpleString('misc', hand) ?? '';
        }
    } else {
        message = 'Natural';
    }
    sender.props.table_setAuxiliaryMessage({
        position: 'left',
        message: {
            bid: receivedCall,
            text: message,
            buttonAuxiliary: undefined,
            buttonOk: undefined,
            buttonCancel: undefined,
            titleColor: undefined,
        },
    });

    // sender.props.setGame({
    //     bidExplanation: {
    //         header: bid,
    //         message,
    //     },
    // });
}
